import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {action, observable} from 'mobx';
import Popover from '@material-ui/core/Popover';
import IconButton from '@material-ui/core/IconButton';
import {secondary} from '../../themes/colors';
import metronomeIcon from '../../assets/images/metronom.svg';
import metronomeIconBlue from '../../assets/images/metronom-blue.svg';
import {withTooltip} from '../toolTip/withTooltip';
import './style.scss';
import VolumeControl from '../VolumeControl';

@withTooltip
@observer
class Metronome extends Component {
    @observable isHowering = false;
    @action toggleMetronome = () => {
        this.isActive = !this.isActive;
        if (this.props.onClick) {
            this.props.onClick(this.isActive);
        }
    };

    @action toggleHower = (val) => {
        if (!this.props.mobileView) {
            this.isHowering = val;
        }
    };

    onMuteChange = () => {
        const {onVolumeChange, volume} = this.props;
        onVolumeChange(volume ? 0 : 0.5);
    };

    setRef = (node) => {
        this.button = node;
    };

    render() {
        const {disabled, isActive, onVolumeChange, volume, isTooltipOpen, onOpenTooltip, onDismissTooltip, dismiss, mobileView} = this.props;
        return (
            <div id="looper-metronome-button" className="metronome">
                <IconButton
                    onClick={this.toggleMetronome}
                    classes={{root: 'metronome-icon'}} disableTouchRipple={true} disabled={disabled}>
                    <img
                        alt=""
                        src={isActive || this.isHowering ? metronomeIconBlue : metronomeIcon}
                        onMouseOver={() => this.toggleHower(true)}
                        onMouseLeave={() => this.toggleHower(false)}
                    />
                </IconButton>
                {!mobileView && <Fragment>
                    <button ref={this.setRef} disabled={disabled} onClick={onOpenTooltip} className="metronome-arrow" id="metronomeVolume"/>
                    <Popover
                        className="metronome-popover"
                        classes={{paper: 'metronome-popover-area'}}
                        anchorEl={this.button}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        open={isTooltipOpen && !dismiss} onClose={onDismissTooltip}>
                        <VolumeControl
                            iconColor={secondary}
                            volume={volume}
                            onVolumeChange={onVolumeChange}
                            onMuteChange={this.onMuteChange}/>
                    </Popover>
                </Fragment>}
            </div>
        );
    }
}

Metronome.propTypes = {
    isActive: PropTypes.bool,
    onClick: PropTypes.func,
    volume: PropTypes.number,
    disabled: PropTypes.bool,
    mobileView: PropTypes.bool
};

export default Metronome;
